import React, { memo, useEffect, useState } from "react"
import parse from "html-react-parser"
import AOS from "aos"
import "aos/dist/aos.css"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import { replaceUnderscoresWithSpaces } from "../../../utils/functions"
import * as style from "./whyAgile.module.css"

const WhyAgile = ({
  CustomClass,
  homeWhyContent,
  homeWhyTitle,
  homeWhyShowSection,
  homeWhySubTitle,
  homeWhyIconTextList,
  homeWhyAgileContect,
  homeWhyVideoUrl
}) => {
  const [loadIframe, setLoadIframe] = useState(false);
  const [videoId, setVideoId] = useState(false);

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  useEffect(() => {
    setVideoId(getYouTubeVideoId(homeWhyVideoUrl))
  }, [homeWhyVideoUrl]);

  function getYouTubeVideoId(url) {
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  }


  return (
    <>
      {homeWhyShowSection === "yes" && (
        <section className={`${CustomClass}`} data-aos="fade-up" data-aos-delay="50" >
          <div className="container">
            <div className="row">
              <div className={style.why_agile_wrap}>
                <SectionsTitle
                  title={replaceUnderscoresWithSpaces(homeWhyTitle)}
                  SubTitle={parse(`${homeWhySubTitle}`)}
                  Content={homeWhyContent}
                  styleCss={{ display: "none" }}
                />
                <div className={style.whyAgileWrap}>
                  <div className={style.leftBox}>
                    <ul
                      className={style.why_agile_listing}
                    >
                      {homeWhyIconTextList?.map((item, index) => {
                        return (
                          <li key={index}>
                            <div className={style.why_agile_info}>
                              <i>{parse(`${item?.homeWhyListIcon}`)}</i>
                              <div className={style.title_div}>
                                {item?.homeWhyListIconText}
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                  <div className={style.videoWrap}>
                    <div>
                      <div className={style.videoDiv}>
                        {!loadIframe ? (
                          <picture
                            className={`${style.thumbnail_image_wrap} ${style.video_icon}`}
                            onClick={() => setLoadIframe(true)}
                          >
                            <img
                              src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                              alt="YouTube video"
                              title="YouTube video"
                              loading="lazy"
                            />
                          </picture>
                        ) : (
                          <iframe
                            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                            style={{ width: "100%", height: "100%" }}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                          />
                        )}
                      </div>
                      <div>
                        <h3>
                          {parse(`${homeWhyAgileContect}`)}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(WhyAgile)
